var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 48,
    height: 48,
    fill: "#0F90FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14C21 12.8954 21.8954 12 23 12H25C26.1046 12 27 12.8954 27 14V16H21V14Z",
    fill: "#0F90FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.6667C11 16.7462 11.7462 16 12.6667 16H21V17C21 18.1046 21.8954 19 23 19H25C26.1046 19 27 18.1046 27 17V16H35.3333C36.2538 16 37 16.7462 37 17.6667V34.3333C37 35.2538 36.2538 36 35.3333 36H12.6667C11.7462 36 11 35.2538 11 34.3333V17.6667ZM20.2731 21.0125C19.4975 20.5514 18.5025 20.5514 17.7269 21.0125C17.0168 21.4347 16.3623 22.1771 16.3623 23.3842C16.3623 25.3626 16.7391 26.0928 16.9275 26.2105C17.3043 26.5049 17.7269 27.1998 17.7269 27.6237C17.7269 28.2321 17.4295 28.5458 16.7136 28.9032C15.7666 29.3759 14.6667 29.9249 14.6667 31.3333H23.3333C23.3333 29.9249 22.2334 29.3759 21.2864 28.9032C20.5705 28.5458 20.2731 28.2321 20.2731 27.6237C20.2731 27.1998 20.6957 26.5049 21.0725 26.2105C21.2609 26.0928 21.6377 25.3626 21.6377 23.3842C21.6377 22.1771 20.9832 21.4347 20.2731 21.0125ZM26 25C25.4477 25 25 25.4477 25 26C25 26.5523 25.4477 27 26 27H32C32.5523 27 33 26.5523 33 26C33 25.4477 32.5523 25 32 25H26ZM25 30C25 29.4477 25.4477 29 26 29H32C32.5523 29 33 29.4477 33 30C33 30.5523 32.5523 31 32 31H26C25.4477 31 25 30.5523 25 30Z",
    fill: "#0F90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.916f4aef429a10e55d40eea433a4b4b4.svg";
export { ForwardRef as ReactComponent };